import { Button, Text } from "@mantine/core"
import React from "react"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import { OrderApi } from "../../apis"
import HttpHandler from "../../utils/http-handler"
import { message } from "../../utils/message"
import { renderBusinessName } from "../../utils/render-business-name"
import { OrderActionCard } from "../order/order-action-card"
import { useSalesActions } from "../order/order-actions"
import { ReasonTooltip } from "../ui"

type Props = {
  action?: any
  setActions?: any
  reload?: any
  reviewed?: any
}

/** Хянах (Ord_SalesModals 2.4.1). The backend lets ORD_EDIT or ORD_SEND review (order/review.ts). */
export function SupplierSalesDynamicReviewForm({ action, setActions, reload, reviewed }: Props) {
  const navigate = useNavigate()
  const { t } = useTranslation(["supplierSales", "common"])
  const [loading, setLoading] = React.useState<boolean>(false)
  const { permissionState } = useSalesActions()
  const perm = permissionState("review")

  const onSubmit = async (review: boolean) => {
    setLoading(true)
    try {
      await OrderApi.review(action?.id, { review })
      setActions([])
      message.success(t(review ? "supplierSales:sales.reviewApprovedSuccess" : "supplierSales:sales.reviewRejectedSuccess"))
      if (reviewed !== "reviewed") reload?.()
      else navigate("/supplier-sales")
    } catch (err) {
      message.error((err as HttpHandler)?.message!)
    } finally {
      setLoading(false)
    }
  }

  const code = action?.salesCode ?? action?.purchaseCode ?? "-"

  return (
    <OrderActionCard
      title={t("supplierSales:sales.modals.review.title")}
      onClose={() => setActions([])}
      loading={loading}
      footer={
        <>
          <Button variant="default" onClick={() => setActions([])}>{t("common:actions.dismiss")}</Button>
          <ReasonTooltip reason={perm.reason}>
            <Button variant="default" onClick={() => onSubmit(false)}>{t("supplierSales:sales.modals.review.reject")}</Button>
          </ReasonTooltip>
          <ReasonTooltip reason={perm.reason}>
            <Button onClick={() => onSubmit(true)}>{t("supplierSales:sales.review")}</Button>
          </ReasonTooltip>
        </>
      }
    >
      <Text fz={14}>
        {t("supplierSales:sales.modals.review.body", { code, business: renderBusinessName(action?.receiverBusiness) })}
      </Text>
    </OrderActionCard>
  )
}
